import * as Yup from "yup";

const grupoPessoasValidator = Yup.object().shape({
  nome: Yup.string().required("Nome"),
  tipoPessoa: Yup.mixed().test(
    "is-number",
    "Tipo de Pessoa",
    (value) => value && !isNaN(Number(value)),
  ),
  ativado: Yup.boolean().required(),
  tabelaPrecoId: Yup.number().nullable(),
});

export default grupoPessoasValidator;
